import Vue from "vue";
import VueCookies from "vue-cookies";
import store from "@/store";

Vue.use(VueCookies);
const rawCurrentCustomerToken = null;
const rawCurrentCart = null;

export default class Uicookie extends Vue {

  static parseCookie = (rawToken: string | null): string | null => {
    if (rawToken) {
      try {
        return JSON.parse(rawToken);
      } catch (e) {
        return null;
      }
    }
    return null;
  };
  static getCookie = (cookieName: string | null): string | null => {
    if (cookieName) {
      try {
        return Vue.$cookies.get(cookieName) || null;
      } catch (e) {
        return null;
      }
    }
    return null;
  };
  /*
   * Customer Token
   */

  static expireAt = (day: string): Date => {
    const dateNow = new Date();
    dateNow.setDate(dateNow.getDate() + parseInt(day));
    return dateNow;
  };

  /*
   *
   */
  static setCustomerToken(newCustomerToken: string | undefined): void {
    const currentCustomerToken = Uicookie.getCookie("qorus_customer_token");
    if (newCustomerToken) {
      if (!currentCustomerToken || currentCustomerToken !== newCustomerToken) {
        Vue.$cookies.set("qorus_customer_token", JSON.stringify(newCustomerToken), "30min", undefined, undefined, true, "Strict");
      }
    }
  }

  static getCustomerToken(): string | null {
    const userToken = Uicookie.getCookie("qorus_customer_token");
    if (userToken) {
      Vue.$cookies.set("qorus_customer_token", userToken, "30min", undefined, undefined, true, "Strict");
      return Uicookie.parseCookie(userToken);
    } else {
      this.deleteCustomerToken();
      return null;
    }
  }

  static deleteCustomerToken(): null {
    Vue.$cookies.remove("qorus_customer_token");
    return null;
  }

  static setCart(newCart: string | undefined): void {
    const currentCart = Uicookie.getCookie("qorus_cart");
    if (newCart) {
      if (!currentCart || currentCart !== newCart) {
        Vue.$cookies.set("qorus_cart", JSON.stringify(newCart), "1d", undefined, undefined, true, "Strict");
      }
    }
  }

  static getCart(): string | null {
    const cart = Uicookie.getCookie("qorus_cart");
    if (cart) {
      Vue.$cookies.set("qorus_cart", cart, "1d", undefined, undefined, true, "Strict");
      return Uicookie.parseCookie(cart);
    } else {
      Uicookie.deleteCart();
      return null;
    }
  }

  static deleteCart(): null {
    Vue.$cookies.remove("qorus_cart");
    store.dispatch("setCart", null).then();
    return null;
  }

  static error(): Promise<unknown> {
    store.dispatch("toggleLoginModal", { open: true, isReloaded: true }).then();
    store.dispatch("setCustomer", null).then();
    store.dispatch("setCart", null).then();
    return Promise.reject({ status: 401 });
  }
}

const currentCart = Uicookie.parseCookie(rawCurrentCart);
const currentCustomerToken = Uicookie.parseCookie(rawCurrentCustomerToken);